export const shoppingStateActionTypes={
    // SET_ACTIVE_CART:"SET_ACTIVE_CART",
    SET_ACTIVE_CART_INDEX:"SET_ACTIVE_CART_INDEX",
    SET_ACTIVE_CART_ID:"SET_ACTIVE_CART_ID"
}

